import { render, staticRenderFns } from "./CallAnalysisInteractive.vue?vue&type=template&id=afbed57a&scoped=true"
import script from "./CallAnalysisInteractive.vue?vue&type=script&lang=js"
export * from "./CallAnalysisInteractive.vue?vue&type=script&lang=js"
import style0 from "./CallAnalysisInteractive.vue?vue&type=style&index=0&id=afbed57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbed57a",
  null
  
)

export default component.exports